import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * 食事内容の値オブジェクト
 */
export class MealContent extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 生成値
   */
  static create(value: string): MealContent {
    return new MealContent(value);
  }
}
